import React, { useState, useEffect } from 'react';
import * as AiIcons from 'react-icons/ai';
import axios from 'axios';
import { baseUrl_ } from '../utils/constants';
import CryptoJS from 'crypto-js';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import Wrapper from '../components/global/Wrapper';
import { wqkgx } from '../config/keys';
import SettingSteps from '../components/SettingPage/SettingSteps';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import secSettingsImg from '../assets/images/dashboard-business/secSettingsLine.svg';
import yellowArrImg from '../assets/images/login/yellowSelector.svg';
import RedImg from '../assets/images/login/redSelector.svg';
import { decryptJson } from '../utils/decryptJson';
import { encryptData } from '../utils/encryptJson';
import { logUserOut } from '../utils/logUserOut';
import TwoFactorAuthToggler from '../components/SettingPage/TwoFactorAuthToggler';
import useOnSuccessfulLogin from '../hooks/useOnSuccessfulLogin';
import customToast, { ToastType } from '../components_/Toast';

interface Props {
  onClick: ({ string }: any | null) => void;
  children?: React.ReactNode;
}

const SettingSecurity = () => {
  const [searchParams] = useSearchParams();
  const step = searchParams.get('step');
  //   console.log(step);
  const [currentPassword, setCurrentPassword] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [passwordShow, setPasswordShow] = useState<boolean>(false);
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(false);
  const [passValid, setPassValid] = useState<boolean>(false);
  const token: any = localStorage.getItem('login-token');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isProceed, setIsProceed] = useState<boolean>(false);

  const navigate = useNavigate();

  //PASSWORD VALIDATION
  const [minimumLength, setMinimumLength] = useState<boolean>(false);
  const [hasSymbol, setHasSymbol] = useState<boolean>(false);
  const [hasUpperCase, setHasUpperCase] = useState<boolean>(false);
  const [hasNumber, setHasNumber] = useState<boolean>(false);
  const [hasLowerCase, setHasLowerCase] = useState<boolean>(false);
  const stored2faEnabled = localStorage.getItem('2fa-enabled');
  const is2faEnabled = stored2faEnabled && JSON.parse(stored2faEnabled);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [isLoading]);

  useEffect(() => {
    if (isProceed) {
      navigate('/settings/business-information?step=3');
    }
  }, [isProceed]);

  const validatePassword = (data: string) => {
    const minLength = new RegExp('(?=.{8,})');
    const symbol = new RegExp('(?=.*[!@#$%^&*(),.?":{}|<>-])');
    const upperCase = new RegExp('(?=.*[A-Z])');
    const numba = new RegExp('(?=.*[0-9])');
    const lowerCase = new RegExp('(?=.*[a-z])');

    if (minLength.test(data)) {
      setMinimumLength(true);
    } else {
      setMinimumLength(false);
    }

    if (symbol.test(data)) {
      setHasSymbol(true);
    } else {
      setHasSymbol(false);
    }

    if (upperCase.test(data)) {
      setHasUpperCase(true);
    } else {
      setHasUpperCase(false);
    }

    if (numba.test(data)) {
      setHasNumber(true);
    } else {
      setHasNumber(false);
    }

    if (lowerCase.test(data)) {
      setHasLowerCase(true);
    } else {
      setHasLowerCase(false);
    }

    if (minimumLength && hasLowerCase && hasNumber && hasSymbol && hasUpperCase) {
      setPassValid(true);
    } else {
      setPassValid(false);
    }

    validateConfirmPassword(password);
  };

  const currentPasswordHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentPassword(event.target.value);
  };

  const passwordHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };
  const confirmPasswordHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPassword(event.target.value);
  };

  // SUBMIT FORM FUNCTION
  const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const encryptedCurrentPassword = CryptoJS.AES.encrypt(currentPassword, wqkgx).toString();
    const encryptedPassword = CryptoJS.AES.encrypt(password, wqkgx).toString();

    setIsLoading(true);

    await axios({
      url: `${baseUrl_}/user/password`,
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token ?? ''}`,
        sessId: localStorage.getItem('sessId') ?? '',
      },
      data: encryptData({
        oldPassword: encryptedCurrentPassword,
        newPassword: encryptedPassword,
      }),
    })
      .then((res) => {
        // const response = decryptJson(res.data);
        customToast(res.data.message, ToastType.success);

        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        logUserOut(err?.status);
        customToast(err.response.data.message, ToastType.error);
      });
  };

  const validateConfirmPassword = (data: string) => {
    if (password === confirmPassword) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const togglePassword = () => {
    setPasswordShow(!passwordShow);
  };

  const saveAndProceed = () => {
    setIsProceed(true);
  };

  return (
    <Wrapper className=' space-y-3 md:space-y-8  !mr-0'>
      <div className=' md:flex  xl:flex'>
        <div className='min-w-[200px] w-[200px] hidden  md:hidden lg:flex xl:flex'>
          <SettingSteps step={step ? step : 2} />
        </div>
        <div className='flex-2 flex-col md:px-[35px] pt-[12px] md:pt-12  md:w-[100%] lg:w-[70%] xl:w-[70%] m-auto'>
          {/* SECURITY COLUMN */}
          <div className='flex flex-col'>
            <label className='w-[114px] h-[42px] font-Poppins not-italic text-lg leading-11 items-center text-[#000000] font-medium'>
              SECURITY
            </label>

            <img
              className='w-[348px] border border-[#dddddd] mt-[16px]'
              src={secSettingsImg}
              alt='line'
            />
            <div className='flex flex-row items-center justify-center p-2.5 gap-2.5 w-[110px] h-[21px] rounded-txr bg-[#c6ecd9] mt-[20px]'>
              <label className='w-[90px] h-[18px] font-Poppins not-italic font-normal text-xs text-[#000000]'>
                How 2FA Works
              </label>
            </div>
            <p className='flex items-center mt-[20px] w-[260px] sm:w-[397px] h-[36px] font-Poppins not-italic font-normal text-xs text-[#000000]'>
              In addition to your username and password, you’ll have to enter a code (delivered to
              your email) at login.
            </p>

            {!is2faEnabled ? (
              <div className='flex flex-row items-start mt-[24px] pl-4 pt-2 w-[260px] sm:w-[459px] h-[95px] border-2 border-[#F51010] rounded-sm bg-[#f510101a]'>
                <img className='' src={RedImg} alt='arrow' />
                <div className='flex flex-col ml-2 sm:ml-6'>
                  <label className='w-[220px] h-[20px] font-Poppins not-italic font-medium text-xs sm:text-sm leading-4.5 text-[#F51010]'>
                    2FA Disabled
                  </label>
                  <p className='mt-[6px] w-[220px] sm:w-[336px] h-[36px] font-Poppins not-italic font-normal text-xs flex items-center text-[#000000]'>
                    You will only be required to use your registered email address and password to
                    login in
                  </p>
                </div>
              </div>
            ) : (
              <div className='flex flex-row items-start mt-[24px] pl-4 pt-2 w-[260px] sm:w-[459px] h-[95px] border-2 border-[#049E26] rounded-sm bg-[#049e2612]'>
                <img className='' src={yellowArrImg} alt='arrow' />
                <div className='flex flex-col ml-2 sm:ml-6'>
                  <label className='w-[220px] h-[20px] font-Poppins not-italic font-medium text-xs sm:text-sm leading-4.5 text-[#028789]'>
                    2FA Enabled
                  </label>
                  <p className='mt-[6px] w-[220px] sm:w-[336px] h-[36px] font-Poppins not-italic font-normal text-xs flex items-center text-[#000000]'>
                    You will be required to authenticate using the six-digit code that will be sent
                    to your registered email.{' '}
                  </p>
                </div>
              </div>
            )}
            <div className='flex justify-between items-center w-[260px] sm:w-[459px]'>
              <div>
                <div className='flex  mt-[20px]'>
                  <label className='font-Poppins not-italic font-medium text-base text-[#000000]'>
                    {is2faEnabled ? 'Disable 2FA?' : 'Enable 2FA?'}
                  </label>
                </div>
                <p className='flex items-center font-Poppins not-italic font-normal text-xs text-[#000000]'>
                  {is2faEnabled
                    ? 'Disabling 2FA makes your profile less secure'
                    : 'Enabling 2FA makes your profile more secure'}{' '}
                </p>
              </div>
              <TwoFactorAuthToggler is2faEnabled={is2faEnabled} />
            </div>
          </div>
          <form onSubmit={submitForm}>
            {/* EDIT PASSWORD COLUMN */}
            <div className='flex flex-col mt-10'>
              <label className='w-[179px] h-[29px] font-Poppins not-italic font-normal text-lg text-[#028789]'>
                Edit Your Password
              </label>
              <div className='flex justify-center'>
                {isLoading ? <ClipLoader color={'#F8B400'} size={50} /> : null}
              </div>
              <p className='mt-[8px] w-[260px] sm:w-[397px] h-[36px] font-Poppins not-italic font-normal text-xs text-[#000000]'>
                To make access to your profile more secure, we advise you to update your password
                often.
              </p>
              <div className='mt-[19px] flex flex-col md:w-[459px] lg:w-[483px]'>
                {/* PASSOWORD DIV */}
                <label className='not-italic font-Poppins font-normal text-sm text-[#212121]'>
                  Current password
                </label>
                <div
                  className={`flex flex-row box-border
              items-center w-52 sm:w-80 md:w-[459px] lg:w-[483px] relative h-[45px] border-[#d4d8de] #F8B400
              border-0 mt-[8px]`}
                >
                  <input
                    className='w-52 sm:w-80 md:w-[459px] lg:w-[483px] invalid:border-red-500 white} outline-[#F8B400] border-[#d4d8de] border h-[45px] pl-3'
                    width='w-52 sm:w-80 md:w-[459px] lg:w-[483px]'
                    maxLength={50}
                    placeholder=''
                    type='password'
                    value={currentPassword}
                    onChange={currentPasswordHandler}
                    // onKeyUp={() => validatePassword(password)}
                  />

                  <div
                    onClick={togglePassword}
                    className='flex items-center absolute left-44 sm:left-72 md:left-52 lg:left-[440px] border-0 justify-center cursor-pointer text-xl text-[#768396] mt-1'
                  ></div>
                </div>
              </div>
              <div className='mt-[27px] flex flex-col md:w-[459px] w-[483px]'>
                {/* PASSOWORD DIV */}
                <label className='not-italic font-Poppins font-normal text-sm text-[#212121]'>
                  New password
                </label>
                <div
                  className={`flex flex-row box-border
              items-center w-52 sm:w-80 md:w-[459px] lg:w-[483px] relative h-[45px] border-[#d4d8de] #F8B400
              border-0 mt-[8px]`}
                >
                  <input
                    className='w-52 sm:w-80 md:w-[459px] lg:w-[483px] invalid:border-red-500 white} outline-[#F8B400] border-[#d4d8de] border h-[45px] pl-3'
                    width='w52 sm:w-80 md:w-[459px] lg:w-[483px]'
                    maxLength={50}
                    placeholder=''
                    type={passwordShow ? 'text' : 'password'}
                    value={password}
                    onChange={passwordHandler}
                    onKeyUp={() => validatePassword(password)}
                  />

                  <div
                    onClick={togglePassword}
                    className='flex items-center absolute left-44 sm:left-72 md:left-[420px] lg:left-[440px] border-0 justify-center cursor-pointer text-xl text-[#768396] mt-1'
                  >
                    {passwordShow ? (
                      <AiIcons.AiOutlineEye onClick={togglePassword} />
                    ) : (
                      <AiIcons.AiOutlineEyeInvisible onClick={togglePassword} />
                    )}
                  </div>
                </div>
              </div>

              <div className='mt-[27px] flex flex-col w-[483px]'>
                {/* CONFIRM PASSWORD DIV */}
                {password && confirmPassword && !isValid && (
                  <p className='font-poppins not-italic font-semibold text-ss text-[#F51010]'>
                    Password does not match!
                  </p>
                )}
                <label className='not-italic font-Poppins font-normal text-sm text-[#212121]'>
                  Confirm password
                </label>
                <div
                  className={`flex flex-row box-border
              items-center w-52 sm:w-80 md:w-[459px] lg:w-[483px] relative h-12 border-[#d4d8de] #F8B400
              border-0 mt-[8px]`}
                >
                  <input
                    className='w-52 sm:w-80 md:w-[459px] lg:w-[483px] invalid:border-red-500 white} outline-[#F8B400] border-[#d4d8de] border h-12 pl-3'
                    width='w-52 sm:w-80 md:w-[459px] lg:w-[483px]'
                    maxLength={50}
                    placeholder=''
                    type={passwordShow ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={confirmPasswordHandler}
                    onKeyUp={() => validateConfirmPassword(confirmPassword)}
                  />

                  <div
                    onClick={togglePassword}
                    className='flex items-center absolute left-44 sm:left-72 md:left-[420px] lg:left-[440px] border-0 justify-center cursor-pointer text-xl text-[#768396] mt-1'
                  >
                    {passwordShow ? (
                      <AiIcons.AiOutlineEye onClick={togglePassword} />
                    ) : (
                      <AiIcons.AiOutlineEyeInvisible onClick={togglePassword} />
                    )}
                  </div>
                </div>
              </div>
              <button
                type='submit'
                disabled={!isValid && !passValid}
                className={`flex items-center justify-center mt-[37px] w-[104px] h-[33px]
                bg-[#ffffff] border-2 border-[#028789] rounded-sm text-[#028789]
                font-Poppins not-italic font-normal text-xs ${
                  isValid && passValid ? 'bg-[#ffffff]' : 'bg-[#e6e6e6]'
                }`}
              >
                Change Now
              </button>

              <div
                className={`flex items-center justify-center mt-[63px] w-[197px] h-[38px]
              rounded-sm cursor-pointer ${isValid && passValid ? 'bg-[#028789] ' : 'bg-[#e6e6e6]'}`}
                onClick={saveAndProceed}
              >
                <label
                  className='not-italic font-Poppins font-normal text-sm text-[#ffffff] cursor-pointer'
                  onClick={saveAndProceed}
                >
                  SAVE AND PROCEED
                </label>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Wrapper>
  );
};

export default SettingSecurity;
